import { Directive, HostBinding } from '@angular/core';

/**
 * Header bar logo image used in a header bar, needed to add the labs- CSS styling.
 */
@Directive({
  selector: '[labsHeaderBarLogo]'
})
export class HeaderBarLogoDirective {
  @HostBinding('class.labs-header-bar-logo') className = true;
}
